export const JWT_KEY = "brainy_access_token";

// 2026-06-13 — 토스트 자동 소거 표준 지속시간(ms). 2024 prod 원래 값(학습창 2000ms)이 표준.
// 이후 챌린지·클래스룸·언어설정 등에서 1500~2400 으로 흩어진 것을 이 값으로 재통일.
// 학습창·홈·카드덱·챌린지·클래스룸 등 모든 토스트가 공유. CTA·환영 등 의도적으로 더 긴
// 토스트(useCardToast KIND_CONFIG 3000)는 예외로 별도 유지.
export const TOAST_DURATION_MS = 2000;
